import type { AnalyticsDataValue } from '../types'

export const extractPrimitiveValue = (value: AnalyticsDataValue): string | number | null => {
  if (value === null) {
    return null
  }

  if (typeof value === 'object' && 'from' in value && 'to' in value) {
    return null
  }

  if (typeof value === 'object' && 'value' in value) {
    return extractPrimitiveValue(value.value)
  }

  return value as string | number
}
